/* MonteFirme — selector de packs: sincroniza la cantidad del formulario de producto. */
(function () {
  'use strict';

  class MFPackSelector extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.cards = Array.from(this.querySelectorAll('.mf-pack__card'));
      this.radios = Array.from(this.querySelectorAll('.mf-pack__radio'));
      this.root =
        this.closest('.shopify-section') ||
        (this.dataset.section ? document.getElementById('shopify-section-' + this.dataset.section) : null) ||
        document;

      this.radios.forEach((radio) => {
        radio.addEventListener('change', () => this._apply(radio));
      });

      // Aplicar la opción marcada al cargar.
      var checked = this.radios.find((r) => r.checked) || this.radios[0];
      if (checked) {
        checked.checked = true;
        // Pequeño retardo para que el web component de cantidad esté listo.
        window.setTimeout(() => this._apply(checked), 60);
      }
    }

    _apply(radio) {
      var qty = parseInt(radio.getAttribute('data-qty'), 10) || 1;

      this.cards.forEach((card) => {
        card.classList.toggle('is-selected', card.contains(radio));
      });

      var qtyComp = this.root.querySelector('quantity-selector-component');
      var input =
        (qtyComp && qtyComp.querySelector('input[name="quantity"]')) ||
        this.root.querySelector('input[name="quantity"]');

      if (input) {
        input.value = String(qty);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Notifica al tema (actualiza la barra sticky, etc.) si el método existe.
      if (qtyComp && typeof qtyComp.onQuantityChange === 'function') {
        try { qtyComp.onQuantityChange(); } catch (e) {}
      }
    }
  }

  if (!customElements.get('mf-pack-selector')) {
    customElements.define('mf-pack-selector', MFPackSelector);
  }
})();
